import type { FC } from 'react';
import Typography from '@mui/material/Typography';
import logo from './../../../assets/logo.svg';
import type { UseQueryResult } from 'react-query';
import type { HotlineMetaData } from '../../modules/algebra/global';

const Header: FC<{ statusQuery?: UseQueryResult<HotlineMetaData> }> = ({ statusQuery }) => {
  const { endpointLogo, endpointTitle } = statusQuery?.data || {}
  return (
    <div className="flex py-4 px-4 md:px-4 items-center justify-between">
      <div className="hotline-logo font-interbold text-6xl text-pc-1">
        <img className="w-44 md:h-full md:w-32" src={endpointLogo || logo} alt="SARNCO Logo" />
      </div>
      <div className="flex justify-between md:w-full items-center pl-0 md:pl-20">
        <div className="hidden md:flex">
          <Typography variant="body1" className="text-tc-5 text-lg border-r-2 border-tc-5 px-0 md:px-5">
            {endpointTitle || (`${process.env.NX_ORGANIZATION_NAME} Hotline`)} 
          </Typography>
          <Typography variant="body1" className="px-5 text-lg text-tc-4">
            Help from a trained support specialist
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Header;
